module.exports = __webpack_public_path__ + "img/CLS-P-210.a0946778.svg";